"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextureParser = void 0;
const pixi_js_1 = require("pixi.js");
class TextureParser {
    constructor() {
        this.priority = 1;
    }
    // async pre (resource: LoaderResource) {
    //   resource.loaded = /\.(png|gif|jpe?g|)$/.test(resource.request.url)
    //   if (resource.loaded) await this.createTexture(resource)
    // }
    createTexture(resource) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const img = new Image();
            img.src = resource.request.url;
            img.crossOrigin = (_b = (_a = resource.options) === null || _a === void 0 ? void 0 : _a.crossOrigin) !== null && _b !== void 0 ? _b : 'anonymous';
            img.onerror = () => reject(new Error(`Failed to load image ${resource.request.url}`));
            img.onload = () => {
                resource.texture = pixi_js_1.Texture.fromLoader(img, resource.request.url, resource.name);
                resolve();
            };
        }));
    }
    use(resource) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!resource.texture && String(resource.response.headers['content-type'] || '').startsWith('image/')) {
                return this.createTexture(resource);
            }
        });
    }
}
exports.TextureParser = TextureParser;
